import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {tap, catchError} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public auth: AuthService,
              public router: Router
  ) {
  }

  intercept(request
              :
              HttpRequest<unknown>, next
              :
              HttpHandler
  ):
    Observable<HttpEvent<unknown>> {

    if (this.auth.isAuthenticated()
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.getToken()}`,
        //  Application: `bGl0ZXJhLWFkbWlu`
        }
      });
    } else {
      request = request.clone({
        setHeaders: {
        //  Application: `bGl0ZXJhLWFkbWlu`
        }
      });
    }
    return next.handle(request)
      .pipe(
        tap(
          event => this.handleResponse(request, event),
          error => this.handleError(request, error)
        )
      );
  }

  handleResponse(req
                   :
                   HttpRequest<any>, event: any
  ) {
    // console.log('Handling response for ', req.url, event);
    // if (event instanceof HttpResponse) {
    //   console.log('Request for ', req.url,
    //     ' Response Status ', event.status,
    //     ' With body ', event.body);
    // }
  }

  handleError(req
                :
                HttpRequest<any>, event: any
  ) {
    if (event instanceof HttpErrorResponse) {
      if (event.status === 401) {
        localStorage.removeItem('token');
        this.router.navigate(['login']);
        // redirect to the login route
        // or show a modal
      }
    }
  }
}
